// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"957809dd","195":"d3f1df07","380":"c3021994","682":"957809dd","688":"984a784a","939":"a47fadc0","999":"7249d89d"}[chunkId] + ".chunk.css";
};